const CLIENT_ID_KEY = 'client_id';

const storeClientIdFromUrl = () => {
  const params = new URLSearchParams(location.search);
  if (!params.has(CLIENT_ID_KEY)) return;
  const clientId = params.get(CLIENT_ID_KEY);
  if (clientId) {
    sessionStorage.setItem(CLIENT_ID_KEY, clientId);
    return;
  }
  sessionStorage.removeItem(CLIENT_ID_KEY);
};

const injectClientIdIntoForms = () => {
  const clientId = sessionStorage.getItem(CLIENT_ID_KEY);
  if (!clientId) return;

  for (const form of document.querySelectorAll('form')) {
    if (!form.querySelector(`input[name="${CSS.escape(CLIENT_ID_KEY)}"]`)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = CLIENT_ID_KEY;
      input.value = clientId;
      form.append(input);
    }
  }
};

/**
 * Reads client_id from the host app URL query param, persists it in
 * sessionStorage, and injects it as a hidden field into all forms so it
 * is forwarded to POST /signup and POST /v2/accounts/recovery calls.
 */
export const initClientIdParam = () => {
  storeClientIdFromUrl();
  injectClientIdIntoForms();
};
